export const passwordValidator = `^.{6,64}$`;
